import React, {Component} from 'react';
import {toastr} from "react-redux-toastr";
import {FILE_SIZE} from "../../config/config";

let selectedFileName = '';

class FileInput extends Component{
    constructor(props) {
        super(props);

        this.state = {
            duration: '',
        };

        selectedFileName = '';

        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
        const { input: { onChange } } = this.props;
        selectedFileName = e.target.files[0].name;
        let type = e.target.files[0].type;
        let size = e.target.files[0].size;
        if( !(type.includes('image/png') || type.includes('image/jpg') || type.includes('image/jpeg'))){
            toastr.warning('Warning', 'Only jpg, jpeg and png images are allowed.');
            return false;
        }else if(size > FILE_SIZE){
            toastr.warning('Warning', 'Only 2MB image size are allowed.');
            return false;
        }else{
            //Remove the validation message on file selection
            if(document.getElementById('media_upload')) {
                document.getElementById('media_upload').innerText = '';
            }

            onChange(e.target.files[0]);

            let video = document.createElement('video');
            video.preload = 'metadata';

            video.onloadedmetadata = function() {
                var duration = video.duration;
            }

            video.src = URL.createObjectURL(e.target.files[0]);

            if(this.props.onChangeProfileImage != undefined) {
                this.props.onChangeProfileImage(e.target.files[0]);
            }
        }

    }

    render(){
        const { input: { value } } = this.props;
        const {input,label, required, meta, } = this.props;  //whatever props you send to the component from redux-form Field

        return(
            <input
                className="form-control"
                type='file'
                onChange={this.onChange}
            />
        )
    }
}

export default FileInput;



// WEBPACK FOOTER //
// ./components/Common/FileInput.js